export default __webpack_public_path__ + "static/O0138-5aa7994686ecfbb47c4be40f08ccdda2.png";